<template>
  <div>
    <bg-field
      label="Add-ons"
      info="If you would like to include a tag on in this test, we will contact you after requesting the test to set this up.</br></br>With individual participant data, you’ll get the 10 individual participant video’s with their personal qualitative feedback and neurofeedback in Brainpeek."
      directions="Please select addons for this test"
      name="addons"
    >
      <bg-checkbox
        v-for="(label, addon) in possibleAddons"
        :key="`addons_${addon}`"
        :value="chosenAddons.includes(addon)"
        :label="label"
        @change="handleAddonsUpdate(addon)"
        class="checkbox"
        :outline="true"
        :disabled="disabled"
      />
    </bg-field>
  </div>
</template>

<style lang="scss" scoped>
.checkbox {
  padding: 15px 20px;
  background-color: white;
  border-radius: 4px;
}
</style>

<script>
import BgCheckbox from "@/components/bg-checkbox";
import BgField from "@/components/bg-field";
export default {
  name: "addons-management",
  components: {
    BgCheckbox,
    BgField,
  },
  props: {
    addons: {
      type: Array,
    },
    handleAddonUpdateCallback: {
      type: Function,
    },
    possibleAddons: {
      type: Object,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleAddonsUpdate(addon) {
      if (this.chosenAddons.includes(addon)) {
        this.chosenAddons = this.chosenAddons.filter(
          (chosenAddon) => chosenAddon != addon
        );
      } else {
        this.chosenAddons.push(addon);
      }
      this.handleAddonUpdateCallback(this.chosenAddons);
    },
  },
  data() {
    return {
      isIndividualParticipantChecked: false,
      isTagOnChecked: false,
      chosenAddons: [],
    };
  },
  mounted() {
    this.chosenAddons = [...this.addons];
    this.isIndividualParticipantChecked = this.chosenAddons.includes(
      "individual_participant"
    );
    this.isTagOnChecked = this.chosenAddons.includes("tagon");
  },
};
</script>
